export const newsFrontendPath = '/news';
export const newsBackendPath = '/backend/news/';

export const newsCreateFrontendPath = '/news/create';
export const newsCreateBackendPath = '/backend/news/create/';

export const newsDetailFrontendPath = '/news/:id/detail';
export const newsDetailBackendPath = '/backend/news/detail/';

export const newsEditFrontendPath = '/news/edit/:id';
export const newsEditBackendPath = '/backend/news/edit/';

export const newsEditStatusFrontendPath = '/news/status/:id';
export const newsEditStatusBackendPath = '/backend/news/edit/status/';


export const newsBannerFrontendPath = '/news/banner';
export const newsBannerBackendPath = '/backend/news/news/banner/';

export const newsBannerCreateFrontendPath = '/news/banner/create';
export const newsBannerCreateBackendPath = '/backend/news/news/banner/create/';

export const newsBannerDetailFrontendPath = '/news/banner/:id/detail';
export const newsBannerDetailBackendPath = '/backend/news/news/banner/detail/';

export const newsBannerEditFrontendPath = '/news/banner/edit/:id';
export const newsBannerEditBackendPath = '/backend/news/news/banner/edit/';

export const newsBannerEditStatusFrontendPath = '/news/banner/status/:id';
export const newsBannerEditStatusBackendPath = '/backend/news/news/banner/edit/status/';


export const bannerFrontendPath = '/banner';
export const bannerBackendPath = '/backend/news/banner/';

export const bannerCreateFrontendPath = '/banner/create';
export const bannerCreateBackendPath = '/backend/news/banner/create/';

export const bannerEditFrontendPath = '/banner/:id';
export const bannerEditBackendPath = '/backend/news/banner/edit/';


// WEBPACK FOOTER //
// ./src/routes/news/urls.js